import React from 'react';
/**
 * CSS class names to align
 *
 * @type {Object}
 */
const ALIGNED_BLOCK = {
    'pdc-text-left': 'left',
    'pdc-text-center': 'center',
    'pdc-text-right': 'right',
    'pdc-text-justify': 'justify'
};

/**
 * Align to CSS class names
 *
 * @type {Object}
 */
export const R_ALIGNED_BLOCK = {
    left: 'pdc-text-left',
    center: 'pdc-text-center',
    right: 'pdc-text-right',
    justify: 'pdc-text-justify'
};

/**
 * Tags to blocks.
 *
 * @type {Object}
 */

const BLOCK_TAGS = {
    p: 'paragraph',
    li: 'list-item',
    ul: 'bulleted-list',
    ol: 'numbered-list',
    blockquote: 'block-quote',
    pre: 'code',
    h1: 'heading-one',
    h2: 'heading-two',
    h3: 'heading-three',
    h4: 'heading-four'
    // h5: 'heading-five',
    // h6: 'heading-six'
};

/**
 * Tags to marks.
 *
 * @type {Object}
 */

const MARK_TAGS = {
    strong: 'bold',
    em: 'italic',
    u: 'underline',
    s: 'strikethrough',
    code: 'code'
};

export const RULES = [
    {
        deserialize(el, next) {
            let type = BLOCK_TAGS[el.tagName.toLowerCase()];
            if (!type) return;

            if (
                (el.tagName.toLowerCase() === 'p' ||
                    el.tagName.toLowerCase() === 'h1' ||
                    el.tagName.toLowerCase() === 'h2' ||
                    el.tagName.toLowerCase() === 'h3' ||
                    el.tagName.toLowerCase() === 'h4') &&
                ALIGNED_BLOCK[el.getAttribute('class')]
            ) {
                // Add align class
                type = `${type}-${ALIGNED_BLOCK[el.getAttribute('class')]}`;
                return {
                    object: 'block',
                    type: type,
                    nodes: next(el.childNodes),
                    data: {
                        className: el.getAttribute('class')
                    }
                };
            }

            return {
                object: 'block',
                type: type,
                nodes: next(el.childNodes)
            };
        },
        serialize(object, children) {
            if (object.object !== 'block') return;
            switch (object.type) {
                case 'paragraph':
                    return <p>{children}</p>;
                case 'paragraph-left':
                case 'paragraph-right':
                case 'paragraph-center':
                case 'paragraph-justify':
                    return <p className={object.data.get('className')}>{children}</p>;
                case 'list-item':
                    return <li>{children}</li>;
                case 'bulleted-list':
                    return <ul>{children}</ul>;
                case 'numbered-list':
                    return <ol>{children}</ol>;
                case 'block-quote':
                    return <blockquote>{children}</blockquote>;
                case 'code':
                    return (
                        <pre>
                            <code>{children}</code>
                        </pre>
                    );
                case 'heading-one':
                    return <h1>{children}</h1>;
                case 'heading-one-left':
                case 'heading-one-right':
                case 'heading-one-center':
                case 'heading-one-justify':
                    return <h1 className={object.data.get('className')}>{children}</h1>;
                case 'heading-two':
                    return <h2>{children}</h2>;
                case 'heading-two-left':
                case 'heading-two-right':
                case 'heading-two-center':
                case 'heading-two-justify':
                    return <h2 className={object.data.get('className')}>{children}</h2>;
                case 'heading-three':
                    return <h3>{children}</h3>;
                case 'heading-three-left':
                case 'heading-three-right':
                case 'heading-three-center':
                case 'heading-three-justify':
                    return <h3 className={object.data.get('className')}>{children}</h3>;
                case 'heading-four':
                    return <h4>{children}</h4>;
                case 'heading-four-left':
                case 'heading-four-right':
                case 'heading-four-center':
                case 'heading-four-justify':
                    return <h4 className={object.data.get('className')}>{children}</h4>;
                default:
                    return;
            }
        }
    },
    {
        deserialize(el, next) {
            const type = MARK_TAGS[el.tagName.toLowerCase()];
            if (!type) return;
            return {
                object: 'mark',
                type: type,
                nodes: next(el.childNodes)
            };
        },
        serialize(object, children) {
            if (object.object !== 'mark') return;
            switch (object.type) {
                case 'bold':
                    return <strong>{children}</strong>;
                case 'italic':
                    return <em>{children}</em>;
                case 'underline':
                    return <u>{children}</u>;
                default:
                    return <em>{children}</em>;
            }
        }
    },
    {
        deserialize(el, next) {
            if (el.tagName !== 'pre') return;
            const code = el.children[0];
            const children = code && code.tagName === 'code' ? code.children : el.children;

            return {
                object: 'block',
                type: 'code',
                nodes: next(children)
            };
        }
    },
    {
        deserialize(el, next) {
            if (el.tagName.toLowerCase() !== 'a') return;
            return {
                object: 'inline',
                type: 'link',
                nodes: next(el.childNodes),
                data: {
                    href: el.getAttribute('href')
                }
            };
        },
        serialize(object, children) {
            if (object.object !== 'inline') return;
            switch (object.type) {
                case 'link':
                    return (
                        <a href={object.data.get('href')} target="_blank" rel="noopener noreferrer">
                            {children}
                        </a>
                    );
                default:
                    return;
            }
        }
    }
];
